export default __webpack_public_path__ + "static/0065-825d89c5390f4306daa0d5ac68941e3b.png";